import { Features } from 'mk2/apps/strollers/schemas';
import { niceNumber } from 'mk2/apps/strollers/utils';
import * as React from 'react';
import styles from './TwoDimsFeature.mscss';

interface OwnProps {
    features: Features;
    feature: any;
}

const hasVal = (value) => {
    return (value !== undefined) && (value !== null);
};

const renderValue = (value) => {
    return hasVal(value) ? niceNumber(value) : '?';
};

export class TwoDimsFeature extends React.Component<OwnProps> {
    public render() {
        const { feature, features } = this.props;

        if (!feature.hasWorthyValue(features)) {
            return null;
        }

        const dims = feature.getDims(features);

        return (
            <div className={styles.TwoDimsFeature}>
                {renderValue(dims.width)}
                &nbsp;×&nbsp;
                {renderValue(dims.depth)}
            </div>
        );
    }
}
